import React from 'react';
import { parseISO } from 'date-fns';
import { hasOwn, safeStartOfMonth } from '@features/price-graph';
export const useCurrentMonth = (openedDate, monthsPricesMap) => {
    const isMonthExist = React.useCallback((date) => {
        const startOfMonth = safeStartOfMonth(date).toISOString();
        return hasOwn(monthsPricesMap, startOfMonth);
    }, [monthsPricesMap]);
    const currentMonthISO = React.useMemo(() => {
        const date = openedDate && safeStartOfMonth(openedDate).toISOString();
        if (!isMonthExist(parseISO(date))) {
            for (const dateISO in monthsPricesMap) {
                if (hasOwn(monthsPricesMap, dateISO)) {
                    return dateISO;
                }
            }
        }
        return date;
    }, [openedDate, monthsPricesMap, isMonthExist]);
    return { currentMonthISO, isMonthExist };
};
